import { useQuery } from "@tanstack/react-query";
import { orderEventsApi } from "../api/orderEvents";

export const orderEventsKey = (orderId: string) => ["order-events", orderId];

export function useOrderEvents(orderId: string | null | undefined, enabled: boolean) {
  return useQuery({
    queryKey: orderEventsKey(orderId ?? ""),
    queryFn: () => orderEventsApi.list(orderId as string),
    enabled: !!orderId && enabled,
    // Zdarzenia dopisują też inne akcje na tej stronie (załączniki, komentarze, POCK) —
    // zawsze pobieraj świeżą listę przy wejściu/powrocie na stronę zamówienia.
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}
